import { useTranslation } from "react-i18next";
import { css } from "styled-components/macro";
import { Block } from "../../components/Block";
import { Header } from "../../components/Header";
import { Wrapper } from "../../components/Wrapper";
import { SEO } from "../../components/SEO";
import { ResetPasswordForm } from "../../forms/auth/ResetPasswordForm";
import { theme } from "../../themes/variables";
import { Headers } from "../../helpers/layout";
import { useResponsive } from "../../hooks/useResponsive";

export function ResetPasswordPage(props: {}) {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Wrapper>
      <SEO>
        <title>{t("auth.reset_password")}</title>
      </SEO>
      <Header />
      <Block
        css={css`
          background-color: ${theme.colors.white};
          padding: ${isMobile ? "20px" : "0"};
        `}
      >
        <div
          css={css`
            width: ${isMobile ? "100%" : "370px"};
            margin: 0 auto;
            padding: 20px 0;
          `}
        >
          <Headers.H3
            css={css`
              text-align: center;
            `}
          >
            {t("auth.reset_Password")}
          </Headers.H3>
          <ResetPasswordForm />
        </div>
      </Block>
    </Wrapper>
  );
}
